import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "../lib/motion";

const ProcessTimeline = ({ phases, dark = false, compact = true, slim = false }) => (
  <div data-testid="process-timeline" className="grid grid-cols-1 md:grid-cols-7">
    {phases.map((p, i) => (
      <motion.div
        key={p.number}
        variants={fadeUp}
        custom={i}
        initial="hidden"
        whileInView="visible"
        viewport={viewportOnce}
        className={`relative border-t md:border-t-0 md:border-l ${
          dark ? "border-white/10" : "border-ink/10"
        } ${i === 0 ? "md:border-l-0 border-t-0" : ""} group ${
          slim
            ? "flex md:flex-col items-baseline md:items-start gap-4 md:gap-0 py-5 md:py-7 md:pr-4"
            : "md:min-h-[300px] p-6 md:p-5 lg:p-6"
        }`}
      >
        <span className={`block transition-colors duration-500 ${
          slim ? "text-2xl font-serif italic" : "text-4xl lg:text-5xl font-serif italic"
        } ${dark ? "text-paper/20 group-hover:text-electric" : "text-ink/15 group-hover:text-cobalt"}`}>
          {p.number}
        </span>
        <h3 className={`${slim ? "md:mt-4 text-base" : "mt-6 text-lg"} font-semibold tracking-tight ${dark ? "text-paper" : "text-coal"}`}>{p.name}</h3>
        {compact && !slim && (
          <p className={`mt-3 text-[13px] leading-relaxed ${dark ? "text-paper/50" : "text-graphite"}`}>{p.objective}</p>
        )}
        <span className={`hidden md:block absolute bottom-0 left-0 h-[2px] w-0 group-hover:w-full transition-[width] duration-700 ease-expo ${dark ? "bg-electric" : "bg-cobalt"}`} />
      </motion.div>
    ))}
  </div>
);

export default ProcessTimeline;
